import { allowedCampaignStatesForRole } from 'constants/campaigns';

export const queryParamsFactory = (formData, role, sort) => {
	const { campaignName, campaignState, channel } = formData;

	// true only when user is located in "Campaign Management" screen
	const isCampaignManagementScreen = window.location.pathname === '/campaign/management/list';

	const campaignStateIdsPreset = isCampaignManagementScreen ? allowedCampaignStatesForRole[role] : null;

	return {
		campaignName,
		campaignStateId: campaignState ? campaignState : campaignStateIdsPreset,
		channelIds: channel,
		size: 15,
		onlyWithContacts: isCampaignManagementScreen,
		page: 0,
		role,
		sort,
	};
};
